import React from "react";
import { Shield, AlertTriangle, LogOut } from "lucide-react";
import { useHistory } from "react-router-dom";

const Unauthorized = () => {
  const history = useHistory();

  const handleLeave = () => {
    // Clear any stored auth data
    localStorage.removeItem("google_token");
    // Redirect to external site or close
    window.location.href = "https://littleexplorers.help";
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-4"
      style={{
        background:
          "linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)",
      }}
    >
      <div
        className="glass-card p-4 p-md-5 text-center"
        style={{
          maxWidth: "500px",
          width: "100%",
        }}
      >
        {/* Warning Icon */}
        <div className="mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-3 mb-3"
            style={{
              width: "80px",
              height: "80px",
              background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
              boxShadow: "0 8px 32px rgba(220, 38, 38, 0.3)",
            }}
          >
            <AlertTriangle size={40} className="text-white" />
          </div>
          <h1
            className="h2 mb-2"
            style={{
              background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Access Denied
          </h1>
          <p className="mb-0" style={{ color: "#9ca3af" }}>
            Unauthenticated - Leave Site
          </p>
        </div>

        {/* Security Notice */}
        <div
          className="mb-4 p-3 rounded-3 text-start"
          style={{
            background: "rgba(255, 255, 255, 0.05)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <div className="d-flex align-items-center gap-3 mb-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                width: "48px",
                height: "48px",
                background: "rgba(220, 38, 38, 0.2)",
              }}
            >
              <Shield size={24} style={{ color: "#ef4444" }} />
            </div>
            <div>
              <p className="text-white fw-semibold mb-1">Access Restricted</p>
              <p
                className="mb-0"
                style={{ color: "#9ca3af", fontSize: "0.875rem" }}
              >
                Your email address is not authorized to access this system.
              </p>
            </div>
          </div>
          <p
            className="mb-0"
            style={{ color: "#6b7280", fontSize: "0.875rem" }}
          >
            This area is restricted to authorized administrators only. If you
            believe this is an error, please contact your system administrator.
          </p>
        </div>

        {/* Leave Button */}
        <button
          type="button"
          onClick={handleLeave}
          className="btn btn-danger w-100 d-flex align-items-center justify-content-center gap-2"
          style={{
            background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
            border: "none",
            padding: "12px 24px",
            borderRadius: "8px",
            fontWeight: 600,
          }}
        >
          <LogOut size={20} />
          Leave Site
        </button>

        {/* Footer */}
        <div
          className="mt-4"
          style={{ color: "#6b7280", fontSize: "0.75rem" }}
        >
          <p className="mb-0">
            For assistance, contact: support@littleexplorers.help
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
